'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';

const footerLinks = {
  Services: [
    { label: 'Web App Pentesting', href: '/services' },
    { label: 'Mobile App Security', href: '/services' },
    { label: 'API Security Testing', href: '/services' },
    { label: 'Network Security', href: '/services' },
    { label: 'Cloud Security', href: '/services' },
    { label: 'Explore All Services', href: '/services' },
  ],
  Compliance: [
    { label: 'ISO 27001', href: '/compliance' },
    { label: 'SOC 2', href: '/compliance' },
    { label: 'PCI DSS', href: '/compliance' },
    { label: 'GDPR', href: '/compliance' },
    { label: 'HIPAA', href: '/compliance' },
    { label: 'Explore All Compliance', href: '/compliance' },
  ],
  'Resources': [
    { label: 'Blog', href: '#' },
    { label: 'Case Studies', href: '#' },
    { label: 'White Papers', href: '#' },
    { label: 'Security Guides', href: '#' },
  ],
  Company: [
    { label: 'About Us', href: '/about' },
    { label: 'Testimonials', href: '/#testimonials' },
    { label: 'Careers', href: '#' },
    { label: 'Trust Center', href: '#' },
    { label: 'Book a Demo', href: '/contact' },
  ],
};

export default function Footer() {
  const [email, setEmail] = useState('');

  return (
    <footer style={{ background: '#0a1d2f', color: '#e2e8f0', fontFamily: 'Inter, sans-serif' }}>
      {/* Awards bar */}
      <div style={{ borderBottom: '1px solid rgba(255,255,255,0.08)', padding: '40px 0' }}>
        <div style={{ maxWidth: '90%', margin: '0 auto' }}>
          <p style={{ textAlign: 'center', fontSize: '14px', color: '#9ca3af', marginBottom: '24px', letterSpacing: '0.05em', textTransform: 'uppercase' }}>
            Awarded And Recognised Across Industries
          </p>
          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '32px', alignItems: 'center' }}>
            {['Global Cyber Alliance', 'IBM Partner', 'DSCI Member', 'CERT-In Empanelled', 'Microsoft for Startups', 'Startup India', 'Oracle for Startups', 'CISO Platform']?.map((award) => (
              <div key={award} style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', padding: '10px 20px', fontSize: '12px', color: '#9ca3af', fontWeight: 500, whiteSpace: 'nowrap' }}>
                {award}
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Main footer */}
      <div style={{ padding: '60px 0 40px' }}>
        <div style={{ maxWidth: '90%', margin: '0 auto' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '280px 1fr', gap: '60px', alignItems: 'start' }}>
            {/* Left: Logo + info */}
            <div>
              <Link href="/" style={{ display: 'inline-block', marginBottom: '24px', lineHeight: 0 }}>
                <Image
                  src="/assets/images/Classy_Elegant_Simple_Name_Logo-1785400291735.png"
                  alt="TechLabs - Advanced Cybersecurity Solutions"
                  width={150}
                  height={45}
                  style={{ objectFit: 'contain', filter: 'brightness(0) invert(1)', height: '45px', width: 'auto' }}
                />
              </Link>
              <div style={{ fontSize: '13px', color: '#9ca3af', lineHeight: '1.7', marginBottom: '20px' }}>
                <p>44-49, Prestige Atlanta,</p>
                <p>Koramangala 3 Block, Koramangala,</p>
                <p>Bengaluru, Karnataka 560034</p>
              </div>
              <div style={{ fontSize: '13px' }}>
                <a href="mailto:info@techlabs.works" style={{ color: '#22c55e', textDecoration: 'none', display: 'block', marginBottom: '6px' }}>info@techlabs.works</a>
                <a href="tel:+918894586775" style={{ color: '#22c55e', textDecoration: 'none' }}>+91 88945 86775</a>
              </div>
            </div>

            {/* Right: Nav links */}
            <nav>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '40px' }}>
                {Object.entries(footerLinks)?.map(([category, links]) => (
                  <div key={category}>
                    <h3 style={{ fontSize: '14px', fontWeight: 700, color: '#fff', marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                      {category}
                    </h3>
                    <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                      {links?.map((link) => (
                        <li key={link?.label} style={{ marginBottom: '10px' }}>
                          <Link
                            href={link?.href}
                            style={{ fontSize: '13px', color: '#9ca3af', textDecoration: 'none', transition: 'color 0.15s' }}
                            className="hover:text-green-400"
                          >
                            {link?.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </nav>
          </div>

          {/* Newsletter + Social */}
          <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)', marginTop: '48px', paddingTop: '40px', display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', gap: '32px' }}>
            {/* Newsletter */}
            <div>
              <p style={{ fontSize: '12px', color: '#9ca3af', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>DON'T MISS OUT!</p>
              <p style={{ fontSize: '15px', color: '#fff', marginBottom: '16px', fontWeight: 500 }}>Join our <strong style={{ color: '#22c55e' }}>10,000+ strong</strong> Cyber Security Squad</p>
              <div style={{ display: 'flex', gap: '0' }}>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e?.target?.value)}
                  placeholder="Email address"
                  style={{
                    padding: '10px 16px',
                    background: 'rgba(255,255,255,0.08)',
                    border: '1px solid rgba(255,255,255,0.15)',
                    borderRight: 'none',
                    borderRadius: '6px 0 0 6px',
                    color: '#fff',
                    fontSize: '13px',
                    outline: 'none',
                    width: '220px',
                  }}
                />
                <button
                  style={{
                    padding: '10px 20px',
                    background: '#22c55e',
                    border: 'none',
                    borderRadius: '0 6px 6px 0',
                    color: '#fff',
                    fontSize: '13px',
                    fontWeight: 600,
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                  }}
                >
                  Subscribe Now
                </button>
              </div>
            </div>

            {/* Accreditations */}
            <div>
              <p style={{ fontSize: '12px', color: '#9ca3af', marginBottom: '12px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Our Accreditation</p>
              <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                {['SOC 2', 'ISO 27001', 'ISO 27017', 'GDPR', 'CERT-In']?.map((cert) => (
                  <div key={cert} style={{ background: 'rgba(34,197,94,0.1)', border: '1px solid rgba(34,197,94,0.3)', borderRadius: '6px', padding: '6px 12px', fontSize: '11px', color: '#22c55e', fontWeight: 600 }}>
                    {cert}
                  </div>
                ))}
              </div>
            </div>

            {/* Social links */}
            <div style={{ display: 'flex', gap: '12px' }}>
              {[
                { name: 'LinkedIn', icon: 'in', href: '#' },
                { name: 'Twitter', icon: 'X', href: '#' },
                { name: 'YouTube', icon: '▶', href: '#' },
                { name: 'Facebook', icon: 'f', href: '#' },
              ]?.map((social) => (
                <a
                  key={social?.name}
                  href={social?.href}
                  aria-label={social?.name}
                  style={{
                    width: '38px',
                    height: '38px',
                    background: 'rgba(255,255,255,0.08)',
                    border: '1px solid rgba(255,255,255,0.12)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#9ca3af',
                    fontSize: '13px',
                    fontWeight: 700,
                    textDecoration: 'none',
                    transition: 'background 0.15s, color 0.15s',
                  }}
                  className="hover:bg-green-500 hover:text-white hover:border-green-500"
                >
                  {social?.icon}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* Bottom bar */}
      <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)', padding: '20px 0' }}>
        <div style={{ maxWidth: '90%', margin: '0 auto', display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', gap: '12px' }}>
          <p style={{ fontSize: '12px', color: '#6b7280' }}>© Copyright 2025 TechLabs Inc. All rights reserved.</p>
          <nav style={{ display: 'flex', gap: '20px' }}>
            {['Privacy Policy', 'Terms & Conditions', 'Cookie Policy', 'Sitemap']?.map((item, i) => (
              <React.Fragment key={item}>
                <a href="#" style={{ fontSize: '12px', color: '#6b7280', textDecoration: 'none' }} className="hover:text-green-400">{item}</a>
                {i < 3 && <span style={{ color: '#374151' }}>|</span>}
              </React.Fragment>
            ))}
          </nav>
        </div>
      </div>
    </footer>
  );
}
